import { getSidebarCustomize } from "../sidebar/getSidebarCustomize.js";
/**
 * Listen to value changes and execute a callback.
 *
 * @param settings
 * @param onChange
 */ function listenChanges(settings, onChange) {
    const customize = getSidebarCustomize();
    for (const section of Object.keys(settings)){
        const sectionSettings = settings[section];
        for (const setting of Object.keys(sectionSettings)){
            const customizeKey = sectionSettings[setting];
            customize(customizeKey, (value)=>{
                value.bind("change", (newValue)=>{
                    onChange(section, setting, newValue);
                });
            });
        }
    }
}
export { listenChanges };
